import { createRouter, createWebHistory } from 'vue-router'
const routes = [
  {
    path: '/',//搜狐通联链接
    name: 'ydq',
    component: () => import('../view/ydq/index.vue')
  },
  {
    path: '/aqy',//爱奇艺链接
    name: 'aqy',
    component: () => import('../view/aqy/index.vue')
  },
  {
    path: '/wyyd',//网易有道链接
    name: 'wyyd',
    component: () => import('../view/wyyd/index.vue')
  },
  {
    path: '/404',
    name: '404',
    component: () => import('../view/404/index.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('../view/404/index.vue')
  },


]
const router = createRouter({
  history: createWebHistory(),
  routes
})
// 路由前置后卫
router.beforeEach((e) => {
  // 开启进度条
});
// 路由后置后卫
router.afterEach((to, from) => {
  // history.pushState(null, null,document.URL)
});
export default router
